import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import translations from '../translations';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const LanguageContext = createContext();

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem('msf_lang') || 'en');

  useEffect(() => {
    // Load language from user profile on mount
    axios.get(`${BACKEND_URL}/api/user/profile`, { withCredentials: true })
      .then(res => {
        if (res.data?.language) {
          setLang(res.data.language);
          localStorage.setItem('msf_lang', res.data.language);
        }
      })
      .catch(() => {});
  }, []);

  const setLanguage = useCallback((code) => {
    setLang(code);
    localStorage.setItem('msf_lang', code);
    // Persist to backend (fire and forget)
    axios.put(`${BACKEND_URL}/api/user/profile?language=${code}`, {}, { withCredentials: true }).catch(() => {});
  }, []);

  const t = useCallback((key, params) => {
    let text = translations[lang]?.[key] || translations.en[key] || key;
    if (params) {
      Object.entries(params).forEach(([k, v]) => {
        text = text.replace(`{${k}}`, v);
      });
    }
    return text;
  }, [lang]);

  return (
    <LanguageContext.Provider value={{ lang, setLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  const ctx = useContext(LanguageContext);
  if (!ctx) return { lang: 'en', setLanguage: () => {}, t: (k) => k };
  return ctx;
}
